import { useApiQuery } from '../query';

export function useSocialMedias(locale: string) {
  const query = useApiQuery<GetSocialMediaResponseTO>(
    '/cms-noauth/v1/social-medias',
    {
      culture: locale,
    },
    undefined,
    undefined,
    { isLogoutApi: true }
  );
  return query.data;
}

type GetSocialMediaResponseTO = {
  appStore: SocialMediaTO[];
  socialMedia: SocialMediaTO[];
};

type SocialMediaTO = {
  iconImage: string;
  name: string;
  url: string;
};
